import React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
import withAuth from '../../../utils/hocs/withAuth';
import withSidebar from '../../../utils/hocs/withSidebar';
import SCOPE from '../../../utils/gate/scope';
import withPermission from '../../../utils/hocs/withPermission';

// Components
import PageWrapper from '../../../components/layout/PageWrapper/PageWrapper';
import CampsView from '../../../components/views/establishment/Products/Camps/Camps';

function Camps() {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('camps.title')}
      hasWhiteWrapper
    >
      <CampsView />
    </PageWrapper>
  );
}

export default withAuth(
  withPermission(
    withSidebar(Camps),
    {
      scopes: [SCOPE.get_ownEst_camp],
    },
  ),
);
